'use client';

import { useState } from 'react';
import useBus from 'use-bus';
import type { UserOverview } from '~/common/types/user-overview';
import { ReplyCommentsDetailContainer } from '@app/(default-layout)/s/[storyId]/_containers/reply-comments-detail-container';
import { getPostReplyKey } from '@app/(default-layout)/s/[storyId]/_utils/comment-util';
import { Box, Paragraph, VStack } from '@styled-system/jsx';

type Props = {
  replyCount: number;
  storyId: string;
  commentId: string;
  author: UserOverview | undefined;
};

export const ReplyContainer = ({
  replyCount,
  storyId,
  commentId,
  author,
}: Props) => {
  const [show, setShow] = useState(false);
  // handle post comment
  useBus(getPostReplyKey(commentId), () => setShow(true));

  return show ? (
    <VStack w="100%" borderTop="1px solid token(colors.separator)">
      <Box
        ml="24px"
        pl="8"
        w="calc(100% - 24px)"
        borderLeft="2px solid token(colors.separator)"
      >
        <ReplyCommentsDetailContainer
          storyId={storyId}
          parentCommentId={commentId}
          author={author}
        />
      </Box>
    </VStack>
  ) : (
    <Box ml="48px" mt="3" cursor="pointer" onClick={() => setShow(true)}>
      <Paragraph fontSize="size_14" color="content_link_primary">
        {replyCount}件の返信を表示
      </Paragraph>
    </Box>
  );
};
